const SkillsData=[
    {
        category:"category-1",
        name:"Frontend",
        skills:[
            { icon: "FaReact", name: "React",type:"Fa" },
            { icon: "FaReact", name: "React Native",type:"Fa" },
            { icon: "FaHtml5", name: "HTML/CSS",type:"Fa" },
            { icon: "RiJavascriptFill", name: "JS/TS",type:"Ri" },
            { icon: "FaFlutter", name: "Flutter",type:"Fa" },
            { icon: "FaVuejs", name: "Vue JS",type:"Fa" },
            { icon: "FaJava", name: "JAVA FX",type:"Fa" },
            { icon: "IoLogoElectron", name: "Electron JS",type:"Io" },
            { icon: "RiNextjsFill", name: "Next JS",type:"Ri" },
        ]
    },
    {
        category:"category-2",
        name:"Backend",
        skills:[
            { icon: "FaNodeJs", name: "Node JS",type:"Fa" },
            { icon: "SiExpress", name: "Express JS",type:"Si" },
            { icon: "FaPhp", name: "PHP",type:"Fa" },
            { icon: "FaLaravel", name: "Laravel",type:"Fa" },
            { icon: "SiFlask", name: "Flask",type:"Si" },
            { icon: "TbBrandCSharp", name: "C# .NET",type:"Tb" },
            { icon: "FaJava", name: "JAVA",type:"Fa" },
            { icon: "TbApi", name: "Rest API",type:"Tb" },
            { icon: "TbBrandKotlin", name: "Kotlin",type:"Tb" },
        ]
    },
    {
        category:"category-3",
        name:"Programming Skills",
        skills:[
            { icon: "TbBrandCpp", name: "C/C++",type:"Tb" },
            { icon: "FaPython", name: "Python",type:"Fa"  },
            { icon: "TbBrandCpp", name: "DSA",type:"Tb"  },
            { icon: "IoGitNetworkOutline", name: "Neural Networks" ,type:"Io" },
            { icon: "FaAppStoreIos", name: "IOS App" ,type:"Fa" },
            { icon: "FaAndroid", name: "Android App" ,type:"Fa" },
            { icon: "FaWindows", name: "Desktop App" ,type:"Fa" },
            { icon: "FaChrome", name: "Web App" ,type:"Fa" },
            { icon: "FaCode", name:"x86 (MASM)", type:"Fa" }
        ]
    },
    {
        category:"category-4",
        name:"Database",
        skills:[
            { icon: "TbSql", name: "SQL",type:"Tb" },
            { icon: "DiMsqlServer", name: "MSSQL",type:"Di" },
            { icon: "SiPostgresql", name: "PGSQL",type:"Si" },
            { icon: "TbBrandMysql", name: "MySQL",type:"Tb" },
            { icon: "SiMongodb", name: "MongoDB",type:"Si" },
            { icon: "RiFirebaseFill", name: "Firebase",type:"Ri" },
        ]
    },
    {
        category:"category-5",
        name:"DevOps & Tools",
        skills:[
            { icon: "FaGitAlt", name: "Git",type:"Fa" },
            { icon: "SiDocker", name: "Docker",type:"Si" },
            { icon: "FaAws", name: "AWS",type:"Fa" },
            { icon: "SiKubernetes", name: "Kubernetes",type:"Si"  },
            { icon: "SiNginx", name: "NginX",type:"Si"  },
            { icon: "SiApache", name: "Apache",type:"Si"  }
        ]
    }
]

export default SkillsData;